import {
	Component,
	OnInit,
	OnDestroy,
	ViewChild,
	ElementRef
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs/Subscription";

// Services
import * as srv from "../share/services";
// Interfaces
import { IComponent, IContact } from "../share/interfaces";
// Enums
import { MessageTypeEnum } from "../share/enums";
// helpers
// import * as helpers from '../helpers';
// directives
import { LastitemDirective } from "../share/directives";

// import * as _ from 'lodash';
@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements IComponent, OnInit {
	// Implement IComponent
	name = "LoginComponent";
	subscriptions: Subscription[] = [];

	// implement local variables
	@ViewChild("newuser") newuser: ElementRef;
	contactsAreLoaded: boolean;
	contacts: IContact[];

	constructor(
		public userSrv: srv.UserService,
		private _logSrv: srv.LogService,
		private _loaderSrv: srv.LoaderService,
		private _storageSrv: srv.StorageService,
		private _msgSrv: srv.MessageService,
		private _route: ActivatedRoute,
		private _helperSrv: srv.HelperService
	) {
		"starting".log(this.name);
	}

	ngOnInit() {
		"initiate".log(this.name);
		this.subscriptions.push(
			this._route.data.subscribe((data: { contacts: IContact[] }) => {
				"updating contacts".logWithObject(this.name, data);
				this.contacts = data.contacts;
				this._loaderSrv.SetLoading(this.name, false);
			})
		);

		// this.subscriptions.push(
		//   this.userSrv.TESTCONTACTS.subscribe(contacts => {
		//     'updating contacts'.logWithObject(this.name, contacts);
		//     this.contactsAreLoaded = false;

		//     if (contacts !== undefined && contacts !== null) {
		//       // _.sortBy(contacts, [(c: IContact) => {
		//       //   console.log('contacts', c);
		//       //   return c.FullName;
		//       // }]);

		//       this.contacts = contacts;
		//       this._loaderSrv.SetLoading(this.name, false);
		//     }
		//     'updated contacts'.logWithObject(this.name, this.contacts);
		//   })
		// );
		"on init".logWithObject(this.name, [this.userSrv.Data]);
	}

	LoadContact(contact) {
		this._loaderSrv.SetLoading(this.name, true);
		"loader is".logWithObject(this.name, this._loaderSrv.Data.isLoading);
		this.userSrv.setContact(this.name, contact);
		//NH 1/22/18 - Go to the applications page when logging in.
		//this._helperSrv.goToMain();

		this._helperSrv.goToApplications(this.userSrv.Data.contact.AcepId);
	}

	LoadNewUser(user) {
		"new user".logWithObject(this.name, [
			user,
			this.newuser,
			this.newuser.nativeElement.value
		]);
		const acepid = this.newuser.nativeElement.value;
		this._loaderSrv.SetLoading(this.name, true);
		this.userSrv.addTestContact(acepid).then(
			contact => {
				this._logSrv.Debug(this.name, ["LoadNewUser", contact]);
				const existing = this.contacts.filter(c => c.Id === contact.Id);
				if (existing === undefined || existing.length === 0) {
					this.contacts.push(contact);
					this._storageSrv.AddTestContact(contact);
					this._msgSrv.DisplayBothError(
						`${acepid} has been added`,
						false,
						MessageTypeEnum.welldone
					);
				} else {
					this._msgSrv.DisplayBothError(
						`${acepid} already exists`,
						false,
						MessageTypeEnum.warning
					);
				}

				this._loaderSrv.SetLoading(this.name, false);
			},
			fail => {
				this._logSrv.Error(this.name, ["LoadNewUser", fail]);
				this._msgSrv.DisplayBothError(
					`Contact ${acepid} not found`,
					true,
					MessageTypeEnum.ohsnap
				);
			}
		);
	}

	OnLastContactLoaded(contact: IContact) {
		this.contactsAreLoaded = true;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/login/login.component.ts